import { saveNetting } from "../../../networking/NetworkingOrders";

const transformNettingDetail = (ordersBuy, ordersSell) =>{
    const nettinDetailsToSave = [] ;
    if(ordersBuy && ordersBuy.length > 0)
    {
        ordersBuy.forEach((o, index) =>{
        const detail = {
            OrderID: o.BNOrderNo,
            OrderOriginalTotal: o.TotalNetOrderNumber,
            AmountNetted: o.amountToApply,
            SettlementStatus: (o.TotalNetOrderNumber - o.amountToApply) === 0 ? 'Fully Paid' : 'Partially Paid'
        }
        nettinDetailsToSave.push(detail);
        })
    }
    if(ordersSell && ordersSell.length > 0){
        ordersSell.forEach((o, index) =>{
          const detail = {
            OrderID: o.BNOrderNo,
            OrderOriginalTotal: o.TotalNetOrderNumber,
            AmountNetted: o.amountToApply,
            SettlementStatus: (o.TotalNetOrderNumber - o.amountToApply) === 0 ? 'Fully Paid' : 'Partially Paid'
          }
          nettinDetailsToSave.push(detail);
        })
    }
  return nettinDetailsToSave
}

export const save = async(customerId, buyCurrency, ordersBuy, ordersSell, totalBuy, totalSell) =>{
   
  const objNetting = {
    CustomerID: customerId,
    SettlementCurrency: buyCurrency,
    NettingDetails: transformNettingDetail(ordersBuy, ordersSell),
    NettingTotalBuy: totalBuy,
    NettingTotalSell: totalSell,
    NettingBalance: (totalBuy - totalSell < 0) ? totalSell - totalBuy : totalBuy - totalSell,
    UserID: localStorage.getItem('userID')
  }

  const responseSave = await saveNetting(objNetting);

  console.log(responseSave);
  if(responseSave.httpStatusCode !== 200)
  {
    return {Title: 'Error', Message: responseSave.Message, Success: false, NettingID: 0}
  }
  else{
    const messageSave = `Netting was saved successfully. Netting ID: ${responseSave.NettingID} `
    return {Title: 'Success', Message: messageSave, Success: true, NettingID: responseSave.NettingID}
  }
}

